<template>
  <div class="projectPopUpView-all-box">
    <card>
      <form-table-page
        class="index-all-box"
        :data="formData"
        :label="formLabel"
        @Query="Query"
        @Reset="Reset"
      >
        <template slot="userName">
          <el-input v-model="formData.userName" :placeholder="$t('queryForm.pleaseEnter')" />
        </template>

        <template slot="email">
          <el-input v-model="formData.email" :placeholder="$t('queryForm.pleaseEnter')" />
        </template>

        <template slot="roleId">
          <el-select v-model="formData.roleId" :placeholder="$t('queryForm.pleaseSelect')">
            <el-option v-for="item in roleList" :key="'role' + item.id" :label="item.name" :value="item.id" />
          </el-select>
        </template>

        <template slot="authorized">
          <div style="width: 290px">
            <el-radio v-model="formData.authorized" label="1">{{ $t('queryForm.authorized') }}</el-radio>
            <el-radio v-model="formData.authorized" label="0">{{ $t('queryForm.notAuthorized') }}</el-radio>
          </div>
        </template>
      </form-table-page>
    </card>

    <card class="marginTop">
      <div class="table-content-box">
        <table-page
          :table-data="tableData"
          :search-method="handleSearch"
          :total="total"
          :show-pagination="true"
          @selectionChange="handleSelectionChange"
        >
          <template slot="tableItem">
            <el-table-column
              prop="userName"
              :label="$t('formData.userName')"
              align="center"
              show-overflow-tooltip
            />

            <el-table-column
              prop="email"
              :label="$t('formData.companyEmail')"
              align="center"
              show-overflow-tooltip
            />

            <el-table-column
              prop="roleName"
              :label="$t('formData.roleName')"
              align="center"
              show-overflow-tooltip
            />

            <el-table-column
              prop="telephone"
              :label="$t('formData.telephone')"
              align="center"
              show-overflow-tooltip
            />

            <el-table-column
              prop="mobile"
              :label="$t('formData.mobilePhone')"
              align="center"
              show-overflow-tooltip
            />
          </template>
        </table-page>

        <div class="btn-box input-form-btn-list">
          <cus-btn type="return" plain @click="cancel" />

          <cus-btn v-show="queryFormData.authorized === '1'" type="revoke" round @click="save" />
          <cus-btn v-show="queryFormData.authorized === '0'" type="assign" round @click="save" />
        </div>
      </div>
    </card>
  </div>
</template>

<script>
import { roleAllSelect } from '../../api/adminManagement'
import { projectSelectAssign, projectAssign } from '../../api/projectManagement'

export default {
  name: 'ProjectPopUpView',
  data() {
    return {
      multipleSelection: [],
      tableData: [],
      projectId: '',
      pageNumber: 1,
      total: 0,
      roleList: [],
      queryFormData: {
        userName: '', // 用户名称
        email: '', // 公司邮箱
        roleId: '', // 角色ID
        authorized: '0'
      },
      formData: {
        userName: '', // 用户名称
        email: '', // 公司邮箱
        roleId: '', // 角色ID
        authorized: '0' // 是否已授权
      },
      formLabel: {
        userName: 'queryForm.userName', // 用户名称
        email: 'queryForm.companyEmail', // 公司邮箱
        roleId: 'queryForm.roleName', // 角色ID
        authorized: {name: 'queryForm.status', isNoFixedWidth: true} // 是否已授权  projectId
      }
    }
  },
  computed: {
    lang() {
      return this.$store.state.app.language
    }
  },
  watch: {
    lang() {
      this.getRoleAllSelect()
      this.getProjectSelectAssign()
    }
  },
  mounted() {
    const self = this
    window.projectPopUpView = self

    self.projectId = self.$route.query.proId
    self.getRoleAllSelect()
    self.getProjectSelectAssign()
  },
  methods: {
    /**
    * 查询方法
    * @constructor
    */
    Query() {
      this.pageNum = 1
      this.pageSize = 10
      this.queryFormData = { ...this.formData }
      this.getProjectSelectAssign()
    },

    /**
    * 重置
    * @constructor
    */
    Reset() {
      this.pageNum = 1
      this.pageSize = 10
      this.queryFormData = { ...this.formData }
      this.getProjectSelectAssign()
    },

    /**
    * 监听分页
    */
    handleSearch(currentPage, pageSize) {
      this.pageNum = currentPage
      this.pageSize = pageSize
      this.getProjectSelectAssign()
    },

    /**
    * table 选中事件
    * @param val
    */
    handleSelectionChange(val) {
      this.multipleSelection = val
      console.log('11111111', this.multipleSelection)
    },

    /**
    * 取消 关闭弹窗
    */
    cancel() {
      this.$router.push({
        name: this.$route.query.backToPage
      })
    },

    /**
    * 查询项目授权用户列表
    */
    getProjectSelectAssign() {
      const self = this
      const param = {
        projectId: self.projectId || '',
        pageNum: this.pageNum,
        pageSize: this.pageSize, ...self.queryFormData
      }

      projectSelectAssign(param).then(response => {
        if (response.code === 200) {
          this.total = response.data.total

          if (response.data.list && response.data.list.length) {
            response.data.list.forEach(item => {
              item.roleName = Array.isArray(item.roles) && item.roles.length ? item.roles[0].name : ''
            })
          }

          this.tableData = response.data.list || []
        }
      })
    },

    /**
    * 查询用户角色
    */
    getRoleAllSelect() {
      roleAllSelect().then(response => {
        if (response.code === 200) {
          this.roleList = response.data
        } else {
          this.roleList = []
        }
      })
    },

    /**
    * 改变授权
    */
    save() {
      const self = this
      const userIds = []
      if (!self.multipleSelection.length) {
        self.$message.warning(self.$t('tipsList.pleaseSelectUser'))
        return
      }

      self.multipleSelection.forEach(item => {
        userIds.push(item.userId)
      })

      const message = self.queryFormData.authorized === '1' ? self.$t('tipsList.youWantToUndoTheUser') : self.$t('tipsList.youWantUserAuthorization')

      self.$confirm(message, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        projectAssign({
          projectId: self.projectId,
          authorized: self.queryFormData.authorized === '1' ? 0 : 1,
          userIds: userIds
        }).then(response => {
          if (response.code === 200) {
            self.getProjectSelectAssign()
            self.$message.success(response.message)
          } else {
            self.$message.error(response.message)
          }
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
    .table-content-box {
        border-radius: 6px;
        background-color: #ffffff;
        padding: 0 25px 40px 15px;
        margin-top: 0px;
    }

    .btn-box {
        text-align: center;
        margin-top: 40px;
    }
</style>
